import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { getToken } from 'selectors/tokenSelector';
import { formInput, clearFormInput } from 'actions/FormActions';
import { closeRegister, cashFlowRegisterCountSave } from 'actions/EntityActions';
import { getCashFlow, cashInAmount, cleanCashFlowError } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import DecimalInput from 'screens/components/basic/DecimalInput';
import DialogHeader from 'screens/components/basic/DialogHeader';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';

import POSCashDrawerCount from './POSCashDrawerCount';

class POSCashIn extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: false,
            dialogOpenCashFlow: false,
            dialogError: false,
            deviceOffline: false,
            dialogDrawerCountCash: false
        };

        this.redirectToDevice = this.redirectToDevice.bind(this);
    }

    componentWillMount() {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        if (deviceData !== null) {
            this.props.formInput(this.props.cashInAmountByDefault.toFixed(2), this.props.name + "CashInAmount");
        }
    }

    componentWillReceiveProps(newProps) {
        //Checking the Cash-in amount by default on the settings
        if (newProps.cashInAmountByDefault > 0 && this.props.cashInAmountByDefault !== newProps.cashInAmountByDefault) {
            this.props.formInput(newProps.cashInAmountByDefault.toFixed(2), this.props.name + "CashInAmount");
        }

        if (this.props.cashFlow !== newProps.cashFlow || newProps.cashFlow === null) {
            if (newProps.cashFlow !== undefined) {
                // no cash in done for the user and device
                if (newProps.cashFlow === null) {
                    if (newProps.cashInEnabled) {
                        this.openDialog();
                    }
                }
                else if (newProps.cashFlow.belongsToAuthenticatedUser === false || (!newProps.posOrder && newProps.cashFlow.isTodayCashFlow === false)) {
                    this.openDialogOpenCashFlow();
                }
                else if (newProps.cashFlow.id > 0) {
                    this.closeDialog();
                    this.closeDialogOpenCashFlow();
                }
            }
        }

        if (this.props.cashInSavedTime != newProps.cashInSavedTime) {
            let cashFlowId = newProps.cashFlow.id;
            let newCashInId = newProps.cashFlow.cashIns.length > 0 ? newProps.cashFlow.cashIns.slice(-1)[0].id : 0
            this.saveRegisterCount(cashFlowId, newCashInId);
        }

        if (newProps.cashFlowError !== undefined) {
            if (newProps.cashFlowError.success === false) {
                this.setState({ deviceOffline: true });
                this.openDialogError();
            }
        }

        if (this.props.cashFlow !== newProps.cashFlow && (newProps.cashFlow == null || newProps.cashFlow == undefined) && !newProps.cashInEnabled) {

            //paystone in store, open payment gateway if needed
            if (this.props.paystoneInStoreEnabled) {
                this.paystoneOpenPaymentGateway();
            }

            const deviceData = JSON.parse(localStorage.getItem(newProps.deviceKeyName));
            const amount = 0;
            newProps.cashInAmount(amount, deviceData.id, newProps.branchId);
        }

        if (newProps.closeRegistersFromCashinSaveSuccess && this.props.closeRegistersFromCashinSaveSuccess !== newProps.closeRegistersFromCashinSaveSuccess) {
            window.location.reload();
        }
    }

    verifyDevice = () => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        this.props.verifyCashFlow(deviceData.id, this.props.branchId);
    }

    openDialogOpenCashFlow = () => {
        this.setState({ dialogOpenCashFlow: true });
    }

    closeDialogOpenCashFlow = () => {
        this.setState({ dialogOpenCashFlow: false });
    }

    openDialogError = () => {
        this.setState({ dialogError: true });
    }

    closeDialogError = () => {
        this.setState({ dialogError: false });
    }

    openDialog = () => {
        this.setState({ dialog: true });
    }

    closeDialog = () => {
        this.clearSaved();
        this.setState({ dialog: false });
    }

    reloadPage = () => {
        window.location.reload();
    }

    redirectHomePage = () => {
        this.props.navigate('/');
    }

    redirectToDevice = () => {
        this.props.cleanCashFlowError();
        this.props.navigate('/manage/device');

    }

    cashOut = () => {
        // send data to api
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        this.props.closeRegister(deviceData.id, this.props.branchId, true, 0);
    }

    cashIn = () => {
        //paystone in store, open payment gateway if needed
        if (this.props.paystoneInStoreEnabled) {
            this.paystoneOpenPaymentGateway();
        }

        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));
        const amount = this.props.cashInAmountConfirmed;
        this.props.cashInAmount(amount, deviceData.id, this.props.branchId);
        if (this.state.deviceOffline === false) {
            this.openDrawerAndGetMac();
        }
    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    openDrawerAndGetMac = () => {
        let ws = window.posWebSocket;
        if (ws && ws.readyState === WebSocket.OPEN) {
            const model = {
                Command: 'OPEN DRAWER',
                Data: null
            };
            ws.send(JSON.stringify(model));
        }
    }

    openDrawerCountCash = () => {
        this.props.openDrawer();
        this.setState({ dialogDrawerCountCash: true });
    }

    closeDrawerCountCash = () => {
        this.setState({ dialogDrawerCountCash: false });
    }

    onCancel = () => {
        this.props.onCancel();
        this.clearSaved();
    }

    paystoneOpenPaymentGateway = () => {
        let p = this.props;
        let token = getToken();
        fetch(`${p.store.apiUrl}unauthorized/paystoneInStoreData/${this.props.branchId}`, {
            method: "GET",
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'timezone_offset': new Date(Date.now()).getTimezoneOffset()
            }
        }).then(function (response) {
            return response.json();
        }).then(function (data) {
            console.log(data);
            let model = {
                "method": "openPaymentGateway",
                "requestId": new Date().getTime(),
                "targetType": "paymentGatewayConverge",
                "version": "1.0",
                "parameters": {
                    "app": "VMM",
                    "email": data.data.email,
                    "pin": data.data.pin,
                    "userId": data.data.userId,
                    "vendorId": "sc777053",
                    "vendorAppName": 'techpos',
                    "vendorAppVersion": "1.0",
                    "handleDigitalSignature": true,
                    "paymentGatewayEnvironment": "PROD", // change to DEMO in dev env
                    "merchantId": data.data.merchantId,
                    "retrieveAccountInfo": true,
                    "bmsUsername": "j4CBsOLVR8KNuILQi4b0Nw", // change to tJovqWdIQgyLJoiIAgvJNw for dev
                    "bmsPassword": "IJ3VrN3XQkwq3zAwPNDjbAg3gS-3--gSlN7l1e6rqvA" // change to Ty5g09Sz0qR_1XzAoivmUKFTo_9fzBZMcAUqk63Ip_E for dev
                }
            };
            //console.log("request model", model);
            return fetch(`https://localhost:9790/rest/command`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            }).then(function (response) {
                return response.json();
            }).then(function (data) {
                if (data.data && data.data.paymentGatewayCommand && data.data.paymentGatewayCommand.openPaymentGatewayData.paymentGatewayId) {
                    localStorage.setItem("TECHPOS_PAYSTONE_GATEWAY_ID", data.data.paymentGatewayCommand.openPaymentGatewayData.paymentGatewayId);
                } else {
                    alert(this.props.t("pos.cashIn.openPaymentGatewayFailed"));
                }
            });
        });
    }

    saveRegisterCount = (cashFlowId, cashInId) => {

        if ((this.registerCountCheck(this.props.form[`POSCashDrawerCount100Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount50Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount20Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount2Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount1Count`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount25CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount10CentsCount`]) ||
            this.registerCountCheck(this.props.form[`POSCashDrawerCount5CentsCount`]))) {
            let model = {
                HundredCount: this.props.form[`POSCashDrawerCount100Count`],
                FiftyCount: this.props.form[`POSCashDrawerCount50Count`],
                TwentyCount: this.props.form[`POSCashDrawerCount20Count`],
                TenCount: this.props.form[`POSCashDrawerCount10Count`],
                FiveCount: this.props.form[`POSCashDrawerCount5Count`],
                TwoCount: this.props.form[`POSCashDrawerCount2Count`],
                OneCount: this.props.form[`POSCashDrawerCount1Count`],
                TwentyFiveCoinCount: this.props.form[`POSCashDrawerCount25CentsCount`],
                TenCoinCount: this.props.form[`POSCashDrawerCount10CentsCount`],
                FiveCoinCount: this.props.form[`POSCashDrawerCount5CentsCount`],
                Id: cashFlowId,
                BranchId: this.props.branchId,
                Type: LOOKUP.cashFlowInfo.cashFlowCountType.CashIn,
                CashInId: cashInId
            }

            this.props.cashFlowRegisterCountSave(model);
            this.clearSaved();
        }
    }

    registerCountCheck = (item) => {
        return item && Number(item) > 0;
    }

    clearSaved = () => {
        this.props.clearFormInput(`POSCashDrawerCount100Count`);
        this.props.clearFormInput(`POSCashDrawerCount50Count`);
        this.props.clearFormInput(`POSCashDrawerCount20Count`);
        this.props.clearFormInput(`POSCashDrawerCount10Count`);
        this.props.clearFormInput(`POSCashDrawerCount5Count`);
        this.props.clearFormInput(`POSCashDrawerCount2Count`);
        this.props.clearFormInput(`POSCashDrawerCount1Count`);
        this.props.clearFormInput(`POSCashDrawerCount25CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount10CentsCount`);
        this.props.clearFormInput(`POSCashDrawerCount5CentsCount`);
        this.props.clearFormInput(`POSCashOutCashOutAmount`);
        this.props.clearFormInput(`POSCashInCashInAmount`);
    }

    render() {
        const { t } = this.props; 
        return (
            <div>
                <POSCashDrawerCount show={this.state.dialogDrawerCountCash} onCancel={() => this.closeDrawerCountCash()} onConfirm={() => this.closeDrawerCountCash()} source={"cashIn"} />
                {(this.state.dialog) ?
                    <DialogInput
                        title={<DialogHeader text={t("pos.cashIn.cashIn")} classicClass="posDialogClassic" />}
                        modal={true}
                        open={this.state.dialog}
                        actions={[
                            <Button
                                key={3}
                                name="buttonOpenDrawerCountCash"
                                label={t("pos.cashIn.openDrawerAndCountCash")}
                                primary={true}
                                className="btn-space-20"
                                onTouchTap={() => this.openDrawerCountCash()} />,
                            <Button
                                key={1}
                                name="buttonConfirmCashIn"
                                label={t("common.confirm")}
                                primary={true}
                                className="btnNewBrandPOS"
                                onTouchTap={() => this.cashIn()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div className="modal-font-family">
                            <p className="purpleText">{t("pos.cashIn.verifyCashAmount")}</p>
                            <DecimalInput
                                inputStyle={{ fontSize: 16 }}
                                name={`${this.props.name}CashInAmount`}
                                label={t("pos.cashIn.cashInAmountSep")}
                                floatingLabelText={t("pos.cashIn.cashInAmountSep")}
                                hintText={t("pos.cashIn.cashInAmountSep")}
                                fullWidth
                                size="large"
                                required />
                        </div>
                    </DialogInput>
                    : ''
                }

                {
                    (this.props.show) ?
                        <DialogInput
                            title={<DialogHeaderWithClose text={t("pos.cashIn.cashIn")} classicClass="posDialogClassic" classicClassFont="classicClassFont" handleClose={() => this.onCancel()}/>}
                            modal={true}
                            open={this.props.show}
                            actions={[
                                <Button
                                    key={0}
                                    type="CancelButton"
                                    name="buttonCancel"
                                    className="btn-space"
                                    label={t('common.cancel')}
                                    onTouchTap={() => this.onCancel()} />,
                                <Button
                                    key={3}
                                    name="buttonOpenDrawerCountCash"
                                    label={t("pos.cashIn.openDrawerAndCountCash")}
                                    primary={true}
                                    className="btn-space"
                                    onTouchTap={() => this.openDrawerCountCash()} />,
                                <Button
                                    key={1}
                                    name="buttonConfirmCashIn"
                                    label={t("common.confirm")}
                                    primary={true}
                                    onTouchTap={() => this.cashIn()} />]}
                            contentStyle={{ width: '65%' }}>
                            <div className="modal-font-family">
                                <h6>{t("pos.cashIn.verifyCashInAmount")}</h6>
                                <DecimalInput
                                    name={`${this.props.name}CashInAmount`}
                                    label={t("pos.cashIn.cashInAmountSep")}
                                    floatingLabelText={t("pos.cashIn.cashInAmountSep")}
                                    hintText={t("pos.cashIn.cashInAmountSep")}
                                    fullWidth={true}
                                    required />
                            </div>
                        </DialogInput>
                        : ''
                }

                {(this.state.dialogOpenCashFlow) ?
                    <DialogInput
                        title={<DialogHeader text={t("pos.cashIn.cashIn")} classicClass="posDialogClassic" classicClassFont="classicClassFont" />}
                        modal={true}
                        open={this.state.dialogOpenCashFlow}
                        autoScrollBodyContent={true}
                        actions={[
                            <Button
                                key={1}
                                name="buttonHome"
                                label={t("pos.cashIn.backToHome")}
                                primary={false}
                                onTouchTap={() => this.redirectHomePage()} />,
                            <Button
                                key={2}
                                className="pull-right space btnNewBrandPOS"
                                name="buttonTryAgain"
                                label={t("pos.cashIn.closeRegister")}
                                primary={true}
                                onTouchTap={() => this.cashOut()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div className="modal-font-family">
                            <p>
                                {t("pos.cashIn.alreadyOpenShift")}
                                {t("pos.cashIn.onlyOneShiftAllowed")}
                            </p>
                            <p>
                                {t("pos.cashIn.closeRegisterPath")}
                            </p>
                        </div>
                    </DialogInput>
                    : ''
                }

                {(this.state.dialogError) ?
                    <DialogInput
                        title={<DialogHeaderWithClose text={t("pos.buttons.cashDrop")} classicClass="posDialogClassic" handleClose={() => this.onCancel()}/>}
                        modal={true}
                        open={this.state.dialogError}
                        autoScrollBodyContent={true}
                        actions={[
                            <Button
                                key={1}
                                name="buttonHome"
                                label={t("pos.cashIn.gotoDevices")}
                                primary={false}
                                onTouchTap={() => this.redirectToDevice()} />,
                            <Button
                                key={2}
                                className="pull-right space btnNewBrandPOS"
                                name="buttonTryAgain"
                                label={t("pos.cashIn.tryAgain")}
                                primary={true}
                                onTouchTap={() => this.reloadPage()} />]}
                        contentStyle={{ width: '65%' }}>
                        <div className="modal-font-family">
                            <h4>
                                {t("pos.cashIn.deviceOffline")}
                            </h4>
                        </div>
                    </DialogInput>
                    : ''
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        posOrder: state.entity.posOrder,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        cashInAmountByDefault: state.common.applicationSettings.cashInAmountByDefault,
        cashInAmountConfirmed: state.form[ownProps.name + "CashInAmount"] ? parseFloat(state.form[ownProps.name + "CashInAmount"]) : 0,
        cashFlow: state.entity.cashFlow,
        cashFlowError: state.entity.cashFlowError,
        cashInSavedTime: state.entity.cashInSavedTime,
        branchId: state.common.branchId,
        cashInEnabled: state.common.applicationSettings.cashInEnabled,
        closeRegistersFromCashinSaveSuccess: state.form["closeRegistersFromCashinSaveSuccess"],
        paystoneInStoreEnabled: state.common.applicationSettings.paystoneInStoreEnabled,
        store: state.common.store,
        form: state.form,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        formInput: (value, name) => dispatch(formInput(value, name)),
        verifyCashFlow: (deviceId, branchId) => dispatch(getCashFlow(deviceId, branchId)),
        cashInAmount: (amount, deviceId, branchId) => dispatch(cashInAmount(amount, deviceId, ownProps.name, branchId)),
        closeRegister: (deviceId, branchId, fromCashIn, cashoutAmount) => dispatch(closeRegister(deviceId, branchId, fromCashIn, cashoutAmount)),
        cleanCashFlowError: () => dispatch(cleanCashFlowError()),
        cashFlowRegisterCountSave: (model) => dispatch(cashFlowRegisterCountSave(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(withTranslation()(POSCashIn)));